export default __webpack_public_path__ + "static/media/pending.61123abd.png";